export const ro = {
  // Common
  conversation: 'Conversatie',
  connected: 'Conectat',
  disconnected: 'Deconectat',
  loading: 'Se incarca...',
  error: 'Eroare',
  
  // Welcome messages
  welcomeMessage: 'Salut, cu ce te pot ajuta astazi?',
  joinedChat: 's-a alaturat conversatiei',
  
  // Chat actions
  createNewChat: 'Creeaza o noua conversatie',
  newConversation: 'Conversatie noua',
  moreResults: 'Vreau mai multe rezultate',
  
  // Input placeholders
  inputPlaceholder: 'Scrie un mesaj...',
  inputPlaceholderGenerating: 'Se genereaza rezultatele...',
  
  // Loading messages
  collectingInfo: 'Colectez informatiile necesare ...',
  searchingBestResults: 'Iti cautam cele mai bune rezultate ...',
  analyzingDatabase: 'Analizez baza de date pentru cautare ...',
  checkingSpecialOffers: 'Verific ofertele speciale disponibile ...',
  searchingSimilarProducts: 'Cautam produse similare ...',
  preparingRecommendations: 'Pregatesc recomandarile personalizate ...',
  checkingStock: 'Verific stocul si disponibilitatea produselor ...',
  finalizingResponse: 'Finalizez raspunsul cu cele mai relevante optiuni ...',
  
  // Thinking steps
  analyzingRequest: 'Analizez cererea dumneavoastra ...',
  generatingSearchTerms: 'Generez termenii de cautare ...',
  processingSearchTerms: 'Procesez termenii de cautare ...',
  searchingDatabase: 'Caut in baza de date produsele potrivite ...',
  processingResults: 'Procesez rezultatele gasite ...',
  generatingEstimates: 'Generez estimari de timp si cost ...',
  generatingFinalResponse: 'Generez raspunsul final ...',
  processingRequest: 'Findly se gandeste ...',
  
  // Status messages
  waitingPreviousResults: 'Asteptam rezultatele conversatiei anterioare ...',
  checkingContinuation: 'Verific daca conversatia poate continua...',
  
  // Empty states
  noMessagesYet: 'Inca nu sunt mesaje',
  
  // Error messages
  failedCreateChat: 'Nu s-a putut crea o conversatie noua. Te rog incearca din nou.',
  errorCreatingChat: 'Eroare la crearea conversatiei',
  errorSendingMessage: 'Eroare la trimiterea mesajului',
  errorLoadingChats: 'Eroare la incarcarea conversatiilor',
  
  // Cart messages
  productAddedToCart: 'Produsul {{productCode}} a fost adaugat in cos!',
  
  // Chat titles
  defaultChatTitle: 'Chat {{timestamp}}',
  
  // Connection status
  connectionStatusConnected: 'Conectat 🟢',
  connectionStatusDisconnected: 'Deconectat 🔴',

  // Chat encouragement messages (cycled every 5 seconds)
  chatEncouragement1: 'Te pot ajuta să găsești produsele pe care le cauți!',
  chatEncouragement2: 'Ai nevoie de ajutor pentru a găsi ceva specific?',
  chatEncouragement3: 'Lasă-mă să te ajut cu cumpărăturile tale!'
};
